// extracted by mini-css-extract-plugin
export default {"Navbar__head":"Navbar_Navbar__head__62MWr","Navbar__head__center":"Navbar_Navbar__head__center__kPWhp","Navbar__head__right":"Navbar_Navbar__head__right__Dukf4"};